import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-444e86a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "grad",
    gradientTransform: "rotate(90)"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#be90ff",
      "stop-opacity": "1"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "white",
      "stop-opacity": "0.4"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Grid = _resolveComponent("Grid")!
  const _component_Area = _resolveComponent("Area")!
  const _component_Group = _resolveComponent("Group")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Responsive = _resolveComponent("Responsive")!

  return (_openBlock(), _createBlock(_component_Responsive, { class: "w-full" }, {
    main: _withCtx(({ width }) => [
      _createVNode(_component_Chart, {
        size: { width, height: 420 },
        data: _ctx.data,
        margin: _ctx.margin,
        direction: _ctx.direction,
        axis: _ctx.axis
      }, {
        layers: _withCtx(() => [
          _createVNode(_component_Grid, { strokeDasharray: "2,2" }),
          _createVNode(_component_Group, { stacked: true }, {
            default: _withCtx(() => [
              _createVNode(_component_Area, {
                dataKeys: ['name', 'pl'],
                areaStyle: { fill: 'red' }
              }),
              _createVNode(_component_Area, {
                dataKeys: ['name', 'avg'],
                areaStyle: { fill: 'blue' }
              })
            ]),
            _: 1
          }),
          _hoisted_1
        ]),
        widgets: _withCtx(() => [
          _createVNode(_component_Tooltip, {
            borderColor: "#9f7aea",
            config: {
              pl: { color: 'red' },
              avg: { color: 'blue' },
              inc: { hide: true }
            }
          })
        ]),
        _: 2
      }, 1032, ["size", "data", "margin", "direction", "axis"])
    ]),
    _: 1
  }))
}